import {
  DialogTitle,
  DialogContent,
  Typography,
  DialogActions,
  DialogContentText,
} from '@nextiva/next-ui-components';
import React from 'react';
import { WebsiteStatusDialogProps } from 'interface/WizardV3';
import {
  ButtonStyled,
  StyledDialog,
} from '../../CampaignDialog/CustomDialog/CustomDialog.styled';
import { Body2Typo } from '../../CampaignDialog/WizardV3.styled';
import { LinkStyled } from '../RequestWebsiteCard.styled';
import { useWizardContextV3 } from '../../CampaignDialog/WizardContextV3/WizardContextV3';

const dataTestId = 'PlatformAdminUI-Messaging-WebsiteStatusDialog';

export function WebsiteStatusDialog({
  handleDone,
  handleOpenRequestWebsite,
  open,
}: WebsiteStatusDialogProps) {
  const { isWebsiteRequestEmailSent } = useWizardContextV3();
  return (
    <StyledDialog open={open} onClose={handleDone} data-testid={dataTestId}>
      <DialogTitle style={{ padding: 0 }} variant="h5" color="#0B1029">
        Website request status
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {isWebsiteRequestEmailSent && (
            <Body2Typo>
              Our team is working to build your website. We’ll notify you as
              soon as it’s ready.
            </Body2Typo>
          )}
          {!isWebsiteRequestEmailSent && (
            <Body2Typo>
              It looks like you haven’t submitted a request yet.{' '}
              <LinkStyled
                onClick={handleOpenRequestWebsite}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`${dataTestId}-SendEmail`}
              >
                <Typography display="inline" variant="body2">
                  Send email
                </Typography>
              </LinkStyled>{' '}
              to get a website.
            </Body2Typo>
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <ButtonStyled
          data-testid={`${dataTestId}-Button2`}
          color="primary"
          onClick={handleDone}
          variant="contained"
        >
          Done
        </ButtonStyled>
      </DialogActions>
    </StyledDialog>
  );
}
